import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs/internal/BehaviorSubject";
import { Observable } from "rxjs";
import { Product } from "../models/product";
import { OrderService } from "./order-service";
import * as _ from "lodash";

@Injectable({
  providedIn: "root",
})
export class CartService {
  private _openCart: boolean = false;
  private openCart: BehaviorSubject<boolean> = new BehaviorSubject(
    this._openCart
  );

  constructor(private orderService: OrderService) {}

  public setCart() {
    this._openCart = !this._openCart;
    this.openCart.next(this._openCart);
  }

  public getCartStatus(): Observable<boolean> {
    return this.openCart.asObservable();
  }

  public addToCart(product: Product): void {
    let items: Product[];
    items = this.orderService.getOrderItems() || [];
    let newItems = this.checkIfItemExistAddCount(items, product);
    this.orderService.setOrder({ items: newItems });
    // this.toastrService.wait("הוספת פריט", "פריט הוסף בהצלחה");
    // localStorage.setItem("avct_item", JSON.stringify(items));
    // this.calculateLocalCartProdCounts();
  }

  public checkIfItemExistAddCount(items, product: Product) {
    let stop = false;
    _.each(items, (item) => {
      if (
        item.productId === product.productId &&
        _.isEqual(item.toppings, product.toppings)
      ) {
        item.productQuantity += product.productQuantity;
        item.totalPrice = item.productPrice * item.productQuantity;
        stop = true;
        return items;
      }
    });
    if (stop) {
      return items;
    }
    const index = _.maxBy(items, "index") ? _.maxBy(items, "index").index : 0;
    product.index = index + 1;
    items.push(product);
    return items;
  }
  public removeLocalCartProduct(product: Product) {
    const items: Product[] = this.orderService.getOrderItems();
    _.each(items, (item, index) => {
      if (item.index === product.index) {
        items.splice(index, 1);
        return false;
      }
    });
    this.orderService.setOrder({ items: items });
  }

  public changeItemCount(product: Product, countToAdd: number) {
    const items: Product[] = this.orderService.getOrderItems();
    _.each(items, (item) => {
      if (item.index === product.index) {
        if (item.productQuantity + countToAdd <= 0) {
          return;
        }
        const newCount = item.productQuantity + countToAdd;
        const newPrice =
          item.totalPrice +
          (item.totalPrice / item.productQuantity) * countToAdd;
        item.totalPrice = newPrice;
        item.productQuantity = newCount;
      }
    });
    this.orderService.setOrder({ items: items });
  }

  public removeCart() {
    this.orderService.setOrder({ items: [] });
  }

  public getNumberItemsInCart(): Observable<number> {
    return this.orderService.getNumberItemsInCart();
  }
}
